import { Grid, InlineStack, Text } from "@shopify/polaris";
import ReportTable from "../../../components/CustomerReports/ReportTable";
import InfoCard from "../../../components/Common/InfoCard";
import styles from "../../../styles/layouts/Reports/CustomerReport/CustomerReport.module.css";
import { GetUserReport, GetUsersOverview } from "../../../services/user";
import { useEffect, useState } from "react";
import EmptyState from "../../../components/Common/EmptyState";
import useBundlesStore from "../../../store/bundle";
import { GetBundles } from "../../../services/bundle";

const CustomerReport = () => {
  const [userReport, setUserReport] = useState([]);
  const [overview, setOverview] = useState([]);
  const [currentPage] = useState(1);
  const { bundles, setBundles } = useBundlesStore();

  const capitalizeUnderscoreString = (str) => {
    return str
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };
  const fetchUserReport = async () => {
    const { data } = await GetUserReport(currentPage);
    if (data.result) {
      setUserReport(data.result);
    }
  };
  const fetchBundles = async () => {
    if (!bundles.length) {
      const { data } = await GetBundles(currentPage);
      if (data?.result) {
        setBundles(data.result);
      }
    }
  };

  const fetchUsersOverview = async () => {
    const { data } = await GetUsersOverview();
    if (data.result) {
      setOverview(
        Object.entries(data.result).map(([key, value]) => {
          return {
            label: capitalizeUnderscoreString(key),
            value,
          };
        })
      );
    }
  };
  useEffect(() => {
    fetchUserReport();
    fetchUsersOverview();
    fetchBundles();
  }, []);
  return (
    <>
      {!userReport.length ? (
        <EmptyState
          heading={"Your Customer List Awaits!"}
          text={
            "Once you start selling, this is where your happy customers will appear. Don’t worry, the crowd is just around the corner!"
          }
          img="no customer found.svg"
          // btnName={"Add Coupon"}
          redirect={"/coupons/create"}
        />
      ) : (
        <>
          <Grid columns={{ xs: 1, sm: 1, md: 12, lg: 12, xl: 12 }}>
            {overview.map((order) => {
              return (
                <InfoCard
                  columnSpan={{ xs: 4, sm: 4, md: 4, lg: 4, xl: 4 }}
                  label={order.label}
                  value={order.value}
                />
              );
            })}
          </Grid>
          <br />
          <InlineStack align={"space-between"} wrap={false}>
            <InlineStack align="space-around" gap="10">
              <Text as="h3" variant="headingSm">
                Customer Listing table
              </Text>
            </InlineStack>
            <InlineStack align="space-around" gap="4">
              <div className={styles["flex-space"]}>
                {/* <Button variant="primary">Export CSV</Button> */}
                {/* <Search /> */}
              </div>
            </InlineStack>
          </InlineStack>
          <br />
          <ReportTable users={userReport} />
        </>
      )}
    </>
  );
};

export default CustomerReport;
